//#region Libraries
import styled from "styled-components";
import { Link } from 'react-router-dom';
//#endregion

export const ContainerLink = styled(Link)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    gap: 10px;
    padding: 14px;
    height: 88px;
    background-color: var(--light-1);
    transition: 0.4s;
    border-top: 1px solid transparent;
    border-left: 4px solid transparent;
    z-index: 0;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
    &:hover, &.active {
        background-color: var(--light-blue-2);
    }
    &.border-top {
        border-top-color: var(--light-2);
    }
    &.active {
        border-left-color:var(--red-1);
    }
    & .description {
        font-size: 12px;
        font-weight: 500;
        color: var(--light-gray-1) !important;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        text-align: center;
    }
`;